import React from "react";
import { View, ActivityIndicator, TouchableOpacity, Image, Text, StyleSheet } from 'react-native';
import { useDispatch, useSelector } from "react-redux";
import { CaptionNormalDark, BodyBoldDark, CaptionBoldDark } from "./TextStyles";
import styles from "../../shared/styles";
import { Touchable } from "./Button";
import { ProfileAvatar } from "./Image";
import { colors, global } from "../../shared/const";

import splash_holder from "../assets/placeholder.png";
import leftIcon from "../assets/icon/cs_left.png";
import rightIcon from "../assets/icon/cs_right.png";
import RightIcon from '../assets/icon/right_filled.png'
import star_y from '../assets/icon/star_yellow.png'
import star_g from '../assets/icon/star_grey.png'
import checked_box from '../assets/ic_120/checked_box.png'
import check_box from '../assets/ic_120/check_box.png'
import check_box_grey from '../assets/ic_120/check_box_grey.png'
import { FONT_REGULAR } from "../const/Global";
import localize from "../localize";

export * from './Button';
export * from './Header';
export * from './Image';
export * from './Input';
export * from './TaskSuccess';
export * from './TextStyles';

export const RegistrationProgress = ({ progress }) => {
    return(
        <View style={{ justifyContent: "center", marginVertical: 15, flexDirection: 'row' }} >
            <View style={progress >= 1 ? styles.fillProgressDot : styles.progressDot} />
            <View style={progress >= 2 ? styles.fillProgressDot : styles.progressDot} />
            <View style={progress >= 3 ? styles.fillProgressDot : styles.progressDot} />
            <View style={progress >= 4 ? styles.fillProgressDot : styles.progressDot} />
        </View>
    )
}

export const ComponentSeeAll = ({onClick}) => {
    return(
        <TouchableOpacity style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }} onPress={onClick}>
            <View>
                <CaptionNormalDark title={localize.see_all} />
                <CaptionNormalDark title={localize.levels} />
            </View>
            <Image source={RightIcon} style={{ height: 14, width: 14, marginLeft: 3 }} resizeMode="contain"/>
        </TouchableOpacity>
    )
}


export const ProgressBar = ({ progress, start, end }) => {
    return (
        <View>
            <View style={{ flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <View style={{ width: '10%', alignItems: 'center', justifyContent: 'center' }}>
                    <Image source={star_y} style={{ height: 24, width: 24 }} resizeMode="contain"/>
                </View>
                <View style={{ width: '80%', alignItems: 'center', justifyContent: 'center' }}>
                    <Progress progress={progress} />
                </View>
                <View style={{ width: '10%', alignItems: 'center', justifyContent: 'center' }}>
                    <Image source={star_g} style={{ height: 24, width: 24 }} resizeMode="contain"/>
                </View>
            </View>
            <View style={{ justifyContent: 'space-between', flexDirection: 'row' }}>
                <CaptionNormalDark title={start}/>
                <CaptionNormalDark title={end}/>
            </View>
        </View>
    )
}

export const Progress = (props) => {
    return (
        <View style={{ backgroundColor: colors.disable, padding: 4, borderRadius: 10, height: 20, flexDirection: 'row', overflow: 'hidden', width: '100%' }}>
            <View style={{ width: props.progress, backgroundColor: "#FECB00", borderRadius: 10 }} />
        </View>
    )
}

export const RoundedIcon = ({ height, icon, color, onPress }) => {
    return (
        <TouchableOpacity
            style={{ height, width: height, borderRadius: height, backgroundColor: color, justifyContent: 'center', alignItems: 'center' }}
            activeOpacity={0.8}
            onPress={onPress ? onPress : ()=>null}
        >
            {icon}
        </TouchableOpacity>
    )
}

export const RatePointBox = ({ rate }) => {
    return (
        <View style={styles.rate_point}>
            <Image source={star_y} style={{ width: 20, height: 20 }} resizeMode="contain"/>
            <BodyBoldDark title={` + ${rate}`}/>
        </View>
    )
}

export const CheckComponent = (props) => {
    return (
        <Touchable
            {...props} 
            component={(
                <Image source={props.disabled ? check_box_grey : props.checked ? checked_box : check_box} style={{ width: 24, height: 24 }} resizeMode="contain"/>
            )}
        />
    )
}

export const Loading = ({ size, color, visible, isBackgroundVisible }) => {
    if(!size) size = 'small'
    if(!color) color = colors.indigo
    if(!visible) return null;
    return (
        <View style={[pageStyles.loaderContainer, isBackgroundVisible && { backgroundColor: "rgba(0,0,0,0.2)" }]}>
            <ActivityIndicator color={color} size={size}/>
        </View>
    )
}

export const Budge = ({ value }) => {
    if(value === 0) return null;
    return (
        <View style={styles.budge}>
            <Text style={{ color:'#fff', fontSize: 10, fontFamily: FONT_REGULAR, fontWeight: "400", padding: 2 }}>{value}</Text>
        </View>
    )
}

export const GroupIcons = ({ avatar, faces_number}) =>  {
    if(!avatar) 
        return (
            <View style={{ flexDirection: 'row' }}>
                <View style={{ width: 42, height: 42, backgroundColor: colors.app_background, borderRadius: 42}}>
                    <ProfileAvatar src={splash_holder}/>
                </View>
            </View>
        )
    avatar = global.MAKEURL(avatar);
    return (
        <View style={{ flexDirection: 'row', minHeight: 48, position: 'relative', width: 48 }}>
            {
                faces_number >= 1 || faces_number === 0 ? (
                    <View style={{ width: 42, height: 42, backgroundColor: '#fff', borderRadius: 42, marginTop: 2, position: 'absolute'}}>
                        <ProfileAvatar src={{ uri: faces_number > 1 ? "" : avatar }}/>
                    </View>
                ) : null
            }

            {
                faces_number >= 2 ? (
                    <View style={{ width: 42, height: 42, backgroundColor: '#fff', borderRadius: 42, marginLeft: 2, marginTop: 4, position: 'absolute'}}>
                        <ProfileAvatar src={{ uri: faces_number > 2 ? "" : avatar }}/>
                    </View>
                ) : null
            }

            {
                faces_number >= 3 ? (
                    <View style={{ width: 42, height: 42, backgroundColor: '#fff', borderRadius: 42, marginLeft: 4, marginTop: 6, position: 'absolute'}}>
                        <ProfileAvatar src={{ uri: avatar, cache: 'only-if-cached' }}/>
                    </View>
                ) : null
            }
    </View>
)}

export const ListHeader = ({title}) => (
    <View style={styles.conversationTitle}>
        <Image 
            source={leftIcon}
            resizeMode="contain"
            style={{height: 16, width: 16}}
        />
        <BodyBoldDark title={title}/>
        <Image
            source={rightIcon}
            resizeMode="contain"
            style={{height: 16, width: 16}}
        />
    </View>
)

export const ListContainer = ({ color }) => {
    if(!color) color = colors.lightGray;
    return (
        <View style={{ flexDirection: 'row', flex: 1}}>
            <View style={{ width: 55, height: 55, borderRadius: 55, backgroundColor: color }}/>
            <View style={{ paddingLeft: 10, padding : 5, flex: 1 }}>
                <View style={{ width: '75%', height: 15, backgroundColor: color }}/>
                <View style={{ width: '100%', height: 10, backgroundColor: color, marginVertical: 5 }}/>
                <View style={{ width: '20%', height: 10, backgroundColor: color }}/>
            </View>
        </View>
    )
}

export const GraphRow = ({ title, progress, color }) => {
    return (
        <View style={pageStyles.dontChartRow}>

            <View style={pageStyles.charRowItem}>
                <View style={[pageStyles.chartColorLable, { backgroundColor: color }]} />
                <CaptionBoldDark title={title} />
            </View>

            <View style={{ width: '20%' }}>
                <CaptionNormalDark title={progress} />
            </View>

        </View>
    )
}

const pageStyles = StyleSheet.create({
    dontChartRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 50,
        paddingTop: 15,
        paddingHorizontal: 30,
        width: '100%'
    },
    charRowItem:{
        flexDirection: 'row', 
        alignItems: 'center', 
        width: '80%'
    },
    chartColorLable: {
        height: 12,
        width: 18,
        borderRadius: 4,
        marginRight: 6
    },
    loaderContainer: {
        flex: 1, 
        justifyContent: 'center', 
        alignItems: 'center', 
        position: 'absolute',
        height: '100%', 
        width: '100%', 
        // backgroundColor: 'rgba(0,0,0,0.3)',
        paddingVertical: 10
    }
})